import requestv2 from "~/utils/http-v2";

const expenseApi = {
	gets : async (params) => {
		const url = 'v2/expense';
		return await requestv2.get(url, {params});
	},
	add : async (params) => {
		const url = 'v2/expense';
		return await requestv2.post(url, params);
	},
	update : async (params) => {
		const url = `v2/expense/${params.id}`;
		return await requestv2.patch(url, params);
	},
	delete : async (id) => {
		const url = `v2/expense/${id}`;
		return await requestv2.delete(url);
	},

	groupGets: async (params) => {
		const url = 'v2/expense/group';
		return await requestv2.get(url, {params});
	},
	groupAdd : async (params) => {
		const url = 'v2/expense/group';
		return await requestv2.post(url, params);
	},
	groupUpdate : async (params) => {
		const url = `v2/expense/group/${params.id}`;
		return await requestv2.patch(url, params);
	},
	groupDelete : async (id) => {
		const url = `v2/expense/group/${id}`;
		return await requestv2.delete(url);
	},
};

export default expenseApi;